/**
 * Drag-drop type tokens and payload shapes shared between the catalog
 * table and its row-level useDrag / useDrop hooks.
 *
 * Three drag types — categories reorder among themselves, groups reorder
 * within a category, articles reassign to any group or to an "Ungrouped"
 * drop target (any category accepts the ungrouped drop).
 */

export const DRAG_CATEGORY = "catalog/category";
export const DRAG_GROUP = "catalog/group";
export const DRAG_ARTICLE = "catalog/article";

export interface CategoryDragItem {
  kind: typeof DRAG_CATEGORY;
  id: number;
}

export interface GroupDragItem {
  kind: typeof DRAG_GROUP;
  id: number;
  categoryId: number;
}

export interface ArticleDragItem {
  kind: typeof DRAG_ARTICLE;
  chainRootId: number;
  fromGroupId: number | null;
  fromCategoryId: number | null;
}

export type DragItem = CategoryDragItem | GroupDragItem | ArticleDragItem;
